import { render, staticRenderFns } from "./PanelEditTest.vue?vue&type=template&id=cf5020dc&scoped=true&"
import script from "./PanelEditTest.vue?vue&type=script&lang=js&"
export * from "./PanelEditTest.vue?vue&type=script&lang=js&"
import style0 from "./PanelEditTest.vue?vue&type=style&index=0&id=cf5020dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5020dc",
  null
  
)

export default component.exports